import type {DocumentPartsResponse} from "../types";
import {renderNode} from "../renderNode";
import articleClasses from "../HtmlArticle.module.css";
import panelClasses from "./panelContent.module.css";

export const PanelDocumentParts = ({data}: {data: DocumentPartsResponse}) => {
    return (
        <div className={articleClasses.content} data-pw="panel-content">
            {data.parts.map((part, index) => (
                <div className={panelClasses.part} key={`part-${index}`}>
                    {renderNode(
                        part,
                        part.root[0].id,
                        {skipAugmentations: true},
                        `part-${index}`
                    )}
                </div>
            ))}
        </div>
    );
};
